import React, { useState } from "react";
import ReactMde from "react-mde";
import Showdown from "showdown";
import "react-mde/lib/styles/css/react-mde-all.css";

const MarkdownEditor = ({
    initialValue = "",
    onInputChance = (v) => console.error("onInputChance not defined")
}) => {
    const [value, setValue] = useState(initialValue);
    const [selectedTab, setSelectedTab] = useState("write");

    const handleChange = (value) => {
        setValue(value);
        onInputChance(value);
    }

    const converter = new Showdown.Converter();

    return <ReactMde
            value={value}
            onChange={handleChange}
            selectedTab={selectedTab}
            onTabChange={setSelectedTab}
            generateMarkdownPreview={(markdown) =>
                Promise.resolve(converter.makeHtml(markdown))
            }
        />
}

export default MarkdownEditor;

